import React from 'react'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'
import { Box, Flex, Image, ResponsiveSVG } from 'ui/acro'
import { AlomovesIconSVG } from 'images/latest'
import { openGoogleCalendar, openOutlookCalendar, downloadICS } from './utils'
import { getCoachNames } from './utils'

const Container = styled(Flex)({
  background: 'white',
  flexDirection: 'column',
  gap: '24px',
  padding: '20%',
  '@media (min-width: 480px)': {
    padding: '10% 30%'
  }
})

const ClassDetailssection = styled(Flex)({
  flexDirection: 'column',
  textAlign: 'center'
})

const AddToCalendarSection = styled(Flex)({
  flexDirection: 'column',
  gap: '8px'
})

const Title = styled(Text)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '18px',
  letterSpacing: '0.352px'
})

const OtherInfoText = styled(Text)({
  color: '#000',
  fontFamily: 'Proxima-Nova',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '130%',
  textTransform: 'capitalize',
  letterSpacing: '0.48px'
})

const CalendarOption = styled(Flex)({
  fontFamily: 'Proxima-Nova',
  padding: '16px',
  border: '1px solid  #A3A3A3',
  cursor: 'pointer'
})

const AddToCalendarContent = ({ classDetails }) => {
  const {
    videoThumbnail,
    humanDuration,
    title,
    difficultyLevel,
    coaches,
    style,
    seriesName,
    videoTitle,
    video,
    availabilityGating,
    plan
  } = classDetails

  let image
  if (typeof videoThumbnail !== 'undefined') {
    image = videoThumbnail
  }
  const coachNames = getCoachNames(coaches ?? plan?.coaches)

  const pushGA4Events = () => {
    window.dataLayer?.push({
      event: 'class_scheduled',
      class: title,
      instructor: coachNames,
      series: seriesName ?? plan?.title,
      style: style,
      availability: availabilityGating,
      title: videoTitle ?? video?.title
    })
  }

  return (
    <Container>
      <ClassDetailssection>
        {image ? (
          <Box position='relative' mb={['8px', '10px']}>
            <Image
              src={image}
              objectFit='cover'
              position='absolute'
              top='0'
              left='0'
              style={{ aspectRatio: '16/9' }}
              className='class-image'
            />
          </Box>
        ) : (
          <Box mb={['8px', '10px']} className='no-image'>
            <ResponsiveSVG
              width={['68px', '68px', '130px', '130px']}
              height={['68px', '68px', '130px', '130px']}
              SVG={AlomovesIconSVG}
              className='no-thumbnail'
            />
          </Box>
        )}
        <Title>{title}</Title>
        <OtherInfoText>Total Run Time: {humanDuration}</OtherInfoText>
        <OtherInfoText>{coachNames}</OtherInfoText>
        <OtherInfoText>{difficultyLevel}</OtherInfoText>
      </ClassDetailssection>
      <AddToCalendarSection>
        <Title>Add to Your Calendar</Title>
        <CalendarOption
          onClick={() => {
            openGoogleCalendar(classDetails)
            pushGA4Events()
          }}
        >
          Google
        </CalendarOption>
        <CalendarOption
          onClick={() => {
            openOutlookCalendar(classDetails)
            pushGA4Events()
          }}
        >
          {' '}
          Outlook
        </CalendarOption>
        <CalendarOption
          onClick={() => {
            downloadICS(classDetails)
            pushGA4Events()
          }}
        >
          iCal
        </CalendarOption>
      </AddToCalendarSection>
    </Container>
  )
}
export default AddToCalendarContent
